import React from "react";
import Layout from "../../layouts/Layout";
import IconWorkAgreement from "../../components/icons/icon-work-agreement";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
class WorkAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { option } = this.props
    console.log('option >>', option)
    return (
      <Layout>
        <div className="main-header">
          <div className="main-header-text">ข้อตกลงการทำงาน</div>
        </div>
        <div className="main-body view">
          <IconWorkAgreement style={{ margin: "auto", textAlign: "center" }} />
          <div className="row">
            <div className="col-xs-12 ml-15">
              <ul className="detail-body des-work-agreement">
                
                {/* 
                  {
                    option.workAgreement.map((item, index) => {
                      return (
                        <li key={index}>{item.name}</li>
                      )
                    }
                  } 
                */}
                <li>การบันทึกการเข้า-ออก การทำงาน</li>
                <li>บันทึกการเข้า-ออก การทำงาน เป็นอันดับแรก เมื่อมาถึงที่ปฏิบัติงาน และจะไม่มี การขาด ลา มาสาย</li>
                <li>ท่านสามารถจัดการเกี่ยวกับการวางแผน การทำงานไว้ล่วงหน้า ในการใช้ชีวิตของท่านได้อย่างลงตัว เรามีความยินดีสนับสนุนท่านต่อไป</li>
              </ul>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}


function WorkAgreementRoute(props) {
  let navigate = useNavigate();
  return <WorkAgreement navigate={navigate} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(WorkAgreementRoute);
